export default {
  systemInfo: null,
  offline: Date.now(),
  online: Date.now(),
};
